import { render, staticRenderFns } from "./ConnectorsManagement.vue?vue&type=template&id=2b0de04b&scoped=true"
import script from "./ConnectorsManagement.vue?vue&type=script&lang=js"
export * from "./ConnectorsManagement.vue?vue&type=script&lang=js"
import style0 from "./ConnectorsManagement.vue?vue&type=style&index=0&id=2b0de04b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0de04b",
  null
  
)

export default component.exports